import { RouteNames } from '@ui/routes';
export const QUERY_MENU_ID = 'activeMenu';
export var NavBarItemId = /*#__PURE__*/ function(NavBarItemId) {
    // organization lvl
    NavBarItemId["DASHBOARD"] = "navbarItem-Dashboard";
    NavBarItemId["PROJECTS"] = "navbarItem-Projects";
    NavBarItemId["APPLICATIONS"] = "navbarItem-Apps";
    NavBarItemId["TEAMS"] = "navbarItem-Teams";
    NavBarItemId["PEOPLE"] = "navbarItem-People";
    NavBarItemId["SETTINGS"] = "navbarItem-Settings";
    // Project lvl
    NavBarItemId["PROJECT_OVERVIEW"] = "navbarItem-secondary-Overview";
    NavBarItemId["PROJECT_VERSIONS"] = "navbarItem-secondary-Versions";
    NavBarItemId["PROJECT_UML"] = "navbarItem-secondary-UML";
    NavBarItemId["PROJECT_APPLICATION_LIST"] = "navbarItem-project-applications";
    // App lvl
    NavBarItemId["PROJECT_REMOTES"] = "navbarItem-secondary-Remotes";
    NavBarItemId["PROJECT_SETTINGS"] = "navbarItem-secondary-Settings";
    NavBarItemId["APPLICATION_SETTINGS"] = "navbarItem-application-settings";
    NavBarItemId["APPLICATION_ACTIVITY"] = "navbarItem-application-activity";
    NavBarItemId["PROFILE_OVERVIEW"] = "profile-overview";
    NavBarItemId["PROFILE_SETTINGS"] = "profile-settings";
    NavBarItemId["DEVOPS"] = "DevOps";
    NavBarItemId["APPLICATION_AUDIT_LOG"] = "navbarItem-application-audit-log";
    return NavBarItemId;
}({});
export var NavTitle = /*#__PURE__*/ function(NavTitle) {
    NavTitle["All"] = "All";
    NavTitle["APPLICATIONS"] = "Applications";
    NavTitle["BILLING_HISTORY"] = "Billing History";
    NavTitle["COLLABORATIONS"] = "Collaborators and Teams";
    NavTitle["CREATED_BY_ME"] = "Created by me";
    NavTitle["DASHBOARD"] = "Dashboard";
    NavTitle["DEPENDENCIES"] = "Dependencies";
    NavTitle["DEPENDENCY_GRAPH"] = "Dependency Graph";
    NavTitle["EMAILS"] = "Emails";
    NavTitle["ENVIRONMENT"] = "Environment";
    NavTitle["FAVORITE"] = "Favorite";
    NavTitle["GENERAL"] = "General";
    NavTitle["GENERAL_SETTINGS"] = "General Settings";
    NavTitle["MANAGE_SUBSCRIPTIONS"] = "Manage Subscriptions";
    NavTitle["MANAGED"] = "Managed";
    NavTitle["MEMBERSHIP"] = "Membership";
    NavTitle["MODULES"] = "Modules";
    NavTitle["NODE_GRAPH"] = "Node Graph";
    NavTitle["NPM_DEPENDENCIES"] = "npm Dependencies";
    NavTitle["ORGANIZATION"] = "Organization";
    NavTitle["OVERVIEW"] = "Overview";
    NavTitle["PAYMENT_METHODS"] = "Payment Methods";
    NavTitle["PEOPLE"] = "People";
    NavTitle["PROFILE"] = "Profile";
    NavTitle["PROJECTS"] = "Projects";
    NavTitle["PUBLIC_INFORMATION"] = "Public Information";
    NavTitle["PUBLIC_PROFILE"] = "Public Profile";
    NavTitle["QUERY_MENU_NAME"] = "type";
    NavTitle["REMOTES"] = "Remotes";
    NavTitle["REMOVED"] = "Removed";
    NavTitle["SETTINGS"] = "Settings";
    NavTitle["SUBSCRIPTIONS"] = "Subscriptions";
    NavTitle["TAGS"] = "Tags";
    NavTitle["TEAMS"] = "Teams";
    NavTitle["TOKENS"] = "Tokens";
    NavTitle["UML"] = "UML";
    NavTitle["USER_API_TOKENS"] = "API Tokens";
    NavTitle["VERSIONS"] = "Versions";
    NavTitle["DEPLOY_INTEGRATIONS"] = "Deployment Integrations";
    NavTitle["DEFAULT_DEPLOYMENT_INTEGRATIONS"] = "Deployment Integration";
    NavTitle["DEPLOYMENT_AND_ROLLBACK"] = "Deployment and Rollback";
    NavTitle["DEVOPS"] = "DevOps";
    NavTitle["CONTRIBUTOR_LIST"] = "Contributors";
    NavTitle["APPLICATION_AUDIT_LOG"] = "Audit Log";
    NavTitle["ACTIVITY"] = "Activity";
    return NavTitle;
}({});
export const navigations = {
    // organization lvl
    ["navbarItem-Dashboard"]: {
        id: "navbarItem-Dashboard",
        title: "Dashboard",
        items: []
    },
    ["navbarItem-Projects"]: {
        id: "navbarItem-Projects",
        title: "Projects",
        items: [
            "All",
            "Created by me",
            "Favorite",
            "Removed"
        ]
    },
    ["navbarItem-Apps"]: {
        id: "navbarItem-Apps",
        title: "Applications",
        items: []
    },
    ["navbarItem-Teams"]: {
        id: "navbarItem-Teams",
        title: "Teams",
        items: []
    },
    ["navbarItem-People"]: {
        id: "navbarItem-People",
        title: "People",
        items: []
    },
    ["navbarItem-Settings"]: {
        id: "navbarItem-Settings",
        title: "Settings",
        items: [
            "Public Information",
            "Subscriptions"
        ]
    },
    // project lvl
    ["navbarItem-secondary-Overview"]: {
        id: "navbarItem-secondary-Overview",
        title: "Overview",
        items: []
    },
    ["navbarItem-secondary-UML"]: {
        id: "navbarItem-secondary-UML",
        title: "UML",
        items: []
    },
    ["navbarItem-secondary-Versions"]: {
        id: "navbarItem-secondary-Versions",
        title: "Versions",
        items: []
    },
    ["navbarItem-project-applications"]: {
        id: "navbarItem-project-applications",
        title: "Applications",
        items: []
    },
    ["navbarItem-secondary-Remotes"]: {
        id: "navbarItem-secondary-Remotes",
        title: "Remotes",
        items: [
            "Modules",
            "Versions",
            "npm Dependencies"
        ]
    },
    ["navbarItem-secondary-Settings"]: {
        id: "navbarItem-secondary-Settings",
        title: "Settings",
        items: [
            "Tokens",
            "General",
            "Collaborators and Teams"
        ]
    },
    ["navbarItem-application-settings"]: {
        id: "navbarItem-application-settings",
        title: "Settings",
        items: [
            "Tags"
        ]
    },
    ["DevOps"]: {
        id: "DevOps",
        title: "DevOps",
        items: [
            "DevOps"
        ]
    },
    ["navbarItem-application-audit-log"]: {
        id: "navbarItem-application-audit-log",
        title: "Audit Log",
        items: []
    },
    ["navbarItem-application-activity"]: {
        id: "navbarItem-application-activity",
        title: "Activity",
        items: []
    },
    ["profile-overview"]: {
        id: "profile-overview",
        title: "Overview",
        items: [
            "Overview"
        ]
    },
    ["profile-settings"]: {
        id: "profile-settings",
        title: "Settings",
        items: [
            "Settings"
        ]
    }
};
export const pathsWithoutSideMenu = [
    RouteNames.ORGANIZATION,
    RouteNames.ORGANIZATION_MANAGED_APPLICATIONS,
    RouteNames.ORGANIZATION_PEOPLE,
    RouteNames.USER_PROFILE,
    RouteNames.APPLICATION_OVERVIEW,
    RouteNames.ORGANIZATION_TEAM_LIST,
    RouteNames.ORGANIZATION_TEAM,
    RouteNames.NOT_FOUND
];
export const pathsWithoutHeader = [
    RouteNames.NOT_FOUND
];
